import { useAsyncDataLoader } from '../../hooks/useAsyncDataLoader';
import { useAsyncEffect } from '../../hooks/useAsyncEffect';

export const useTipUserList = (): Nullable<string[]> => {
  const { data = [], load } = useAsyncDataLoader<string[]>(async () => {
    if (!import.meta.env.VITE_USERS_FROM) return [];

    const res = await fetch(import.meta.env.VITE_USERS_FROM);
    return res.json();
  });

  useAsyncEffect(() => load(), []);

  return data;
};
